import { createSlice } from '@reduxjs/toolkit';

const accountsSlice = createSlice({
  name: 'accounts',
  initialState: {
    chartOfAccounts: [],
  },
  reducers: {
    setChartOfAccounts: (state, action) => {
      state.chartOfAccounts = action.payload;
    },
  },
});

export const { setChartOfAccounts } = accountsSlice.actions;
export default accountsSlice.reducer;